import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sh-components',
  templateUrl: './components.component.html',
  styleUrl: './components.component.scss',
  standalone: false
})
export class ComponentsComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
